/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseActionContextRequest } from './ResponseActionContextRequest';
import {
    ResponseActionContextRequestFromJSON,
    ResponseActionContextRequestFromJSONTyped,
    ResponseActionContextRequestToJSON,
    ResponseActionContextRequestToJSONTyped,
} from './ResponseActionContextRequest';

/**
 * 
 * @export
 * @interface ResponseActionExecuteRequest
 */
export interface ResponseActionExecuteRequest {
    /**
     * 
     * @type {string}
     * @memberof ResponseActionExecuteRequest
     */
    actionId?: string;
    /**
     * 
     * @type {ResponseActionContextRequest}
     * @memberof ResponseActionExecuteRequest
     */
    context?: ResponseActionContextRequest;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResponseActionExecuteRequest
     */
    parameters?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ResponseActionExecuteRequest
     */
    clientToken?: string;
}

/**
 * Check if a given object implements the ResponseActionExecuteRequest interface.
 */
export function instanceOfResponseActionExecuteRequest(value: object): value is ResponseActionExecuteRequest {
    return true;
}

export function ResponseActionExecuteRequestFromJSON(json: any): ResponseActionExecuteRequest {
    return ResponseActionExecuteRequestFromJSONTyped(json, false);
}

export function ResponseActionExecuteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseActionExecuteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'actionId': json['actionId'] == null ? undefined : json['actionId'],
        'context': json['context'] == null ? undefined : ResponseActionContextRequestFromJSON(json['context']),
        'parameters': json['parameters'] == null ? undefined : json['parameters'],
        'clientToken': json['clientToken'] == null ? undefined : json['clientToken'],
    };
}

export function ResponseActionExecuteRequestToJSON(json: any): ResponseActionExecuteRequest {
    return ResponseActionExecuteRequestToJSONTyped(json, false);
}

export function ResponseActionExecuteRequestToJSONTyped(value?: ResponseActionExecuteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actionId': value['actionId'],
        'context': ResponseActionContextRequestToJSON(value['context']),
        'parameters': value['parameters'],
        'clientToken': value['clientToken'],
    };
}

